import React from 'react';
import { renderDescriptionHtml } from '../utils/renderDescription';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom'
import backIcon from '../Assets/arrow-back.png'
import './DocArticle.css';
import { useEffect, useState,useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

function DocArticle ({code,title}) {
  const { category, id } = useParams();
    console.log("Page Route: " + category + " /  "+id)
    const navigate = useNavigate(); // Initialize useNavigate for programmatic navigation

  function nav_back (){

    if (src == "search")
   navigate(-1)
    //navigate(`/search?q=${query}`); // Navigate without reloading the page
    else
      navigate("/"+category+"?s="+s)
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const s = searchParams.get("s") || "s";

  const src =searchParams.get("src")

  const divRef = useRef(null);
  const articleContainerRef = useRef(null);

  const scrollToTop = () => {
    // Accessing the current property of the ref to get the DOM node
    const divElement = divRef.current;
    // Scroll the div to the top
    if (divElement) {
      divElement.scrollTop = 0;
    }
  };

//download  categories
var categoryTitles = {}
const [content_data, setData] = useState(null);

useEffect(() => {
  if (!category || !id) return;
  const source = s || "s";
  const url = `https://api.tablemate.net/fetchDocArticles.php?category=${encodeURIComponent(category)}&id=${encodeURIComponent(id)}&s=${encodeURIComponent(source)}`;
  api.fetch(url)
    .then(async (response) => {
      const text = await response.text();
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${text.slice(0, 200)}`);
      }
      try {
        return JSON.parse(text);
      } catch {
        throw new Error("Server returned invalid JSON. Response: " + text.slice(0, 200));
      }
    })
    .then((content_data) => {
      setData(content_data);
      if (Array.isArray(content_data) && content_data.length > 0) {
        renderArticle(content_data);
      } else {
        setArticleTitle("Article not found");
        setProjectCategories(<p>No article found.</p>);
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      setArticleTitle("Error loading article");
      setProjectCategories(<p>Failed to load article. Please try again.</p>);
    });
}, [category, id, s]);

const [articleTitle, setArticleTitle] = useState("Loading...");
const [docArticle, setProjectCategories] = useState(false);
const [lightboxSrc, setLightboxSrc] = useState(null);
const [lightboxZoom, setLightboxZoom] = useState({ scale: 1, x: 0, y: 0 });
const lightboxDragRef = useRef(null);
const lightboxPinchRef = useRef(null);
const lightboxOverlayRef = useRef(null);
const lightboxZoomRef = useRef(lightboxZoom);
lightboxZoomRef.current = lightboxZoom;
const MIN_ZOOM = 1;
const MAX_ZOOM = 5;

  const openLightbox = (src) => {
    if (!src) return;
    setLightboxZoom({ scale: 1, x: 0, y: 0 });
    setLightboxSrc(src);
  };

  const closeLightbox = () => {
    setLightboxSrc(null);
    setLightboxZoom({ scale: 1, x: 0, y: 0 });
  };

  const clampZoom = (scale) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, scale));

  const zoomBy = (factor, originX = 0, originY = 0) => {
    setLightboxZoom((prev) => {
      const nextScale = clampZoom(prev.scale * factor);
      if (nextScale === prev.scale) return prev;
      if (nextScale === 1) return { scale: 1, x: 0, y: 0 };
      const ratio = nextScale / prev.scale;
      return {
        scale: nextScale,
        x: originX - (originX - prev.x) * ratio,
        y: originY - (originY - prev.y) * ratio,
      };
    });
  };

  const resetZoom = () => setLightboxZoom({ scale: 1, x: 0, y: 0 });

  const getLightboxFilename = () => {
    try {
      const path = new URL(lightboxSrc, window.location.href).pathname;
      const name = path.split('/').pop();
      if (name && /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(name)) return name;
    } catch {
      /* ignore */
    }
    return 'screenshot.png';
  };

  const downloadLightboxImage = async () => {
    if (!lightboxSrc) return;
    const filename = getLightboxFilename();
    try {
      const response = await fetch(lightboxSrc, { mode: 'cors' });
      if (!response.ok) throw new Error('fetch failed');
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    } catch {
      const link = document.createElement('a');
      link.href = lightboxSrc;
      link.download = filename;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  const printLightboxImage = () => {
    if (!lightboxSrc) return;
    const printWindow = window.open('', '_blank', 'noopener,noreferrer');
    if (!printWindow) return;
    const safeSrc = lightboxSrc.replace(/"/g, '&quot;');
    printWindow.document.write(`<!DOCTYPE html><html><head><title>Print screenshot</title>
<style>
  html, body { margin: 0; padding: 0; background: #fff; }
  img { display: block; max-width: 100%; max-height: 100vh; margin: 0 auto; object-fit: contain; }
  @media print {
    html, body { height: auto; }
    img { max-width: 100%; max-height: 100%; page-break-inside: avoid; }
  }
</style></head><body>
<img src="${safeSrc}" alt="Screenshot" onload="window.focus(); window.print();" />
</body></html>`);
    printWindow.document.close();
  };

  // Mark portrait images, wrap with expand control, enable click-to-fullscreen
  useEffect(() => {
    if (!docArticle || !articleContainerRef.current) return;
    const container = articleContainerRef.current;
    const imgs = container.querySelectorAll('.doc-article-body img, .doc-article-poster img');
    const checkPortrait = (img) => {
      if (img.naturalWidth && img.naturalHeight && img.naturalHeight > img.naturalWidth) {
        img.classList.add('img-portrait');
      }
    };
    const wrapImage = (img) => {
      if (img.closest('.doc-article-img-wrap')) return;
      const wrap = document.createElement('span');
      wrap.className = 'doc-article-img-wrap';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);

      const expandBtn = document.createElement('button');
      expandBtn.type = 'button';
      expandBtn.className = 'doc-article-img-expand';
      expandBtn.title = 'Expand image';
      expandBtn.setAttribute('aria-label', 'Expand image');
      expandBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>';
      expandBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(img.currentSrc || img.src);
      });
      wrap.appendChild(expandBtn);

      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => openLightbox(img.currentSrc || img.src));
    };
    imgs.forEach((img) => {
      wrapImage(img);
      if (img.complete) {
        checkPortrait(img);
      } else {
        img.addEventListener('load', () => checkPortrait(img));
      }
    });
  }, [docArticle]);

  useEffect(() => {
    if (!lightboxSrc) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === '+' || e.key === '=') zoomBy(1.2);
      if (e.key === '-' || e.key === '_') zoomBy(1 / 1.2);
      if (e.key === '0') resetZoom();
    };
    const onWheel = (e) => {
      e.preventDefault();
      const overlay = lightboxOverlayRef.current;
      if (!overlay) return;
      const rect = overlay.getBoundingClientRect();
      const originX = e.clientX - rect.left - rect.width / 2;
      const originY = e.clientY - rect.top - rect.height / 2;
      zoomBy(e.deltaY < 0 ? 1.15 : 1 / 1.15, originX, originY);
    };
    document.addEventListener('keydown', onKeyDown);
    const overlay = lightboxOverlayRef.current;
    if (overlay) overlay.addEventListener('wheel', onWheel, { passive: false });
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      if (overlay) overlay.removeEventListener('wheel', onWheel);
      document.body.style.overflow = prevOverflow;
    };
  }, [lightboxSrc]);

const renderArticle =  (content_data) => {
  const page = renderDescriptionHtml(
    content_data[0]?.description,
    "https://admin.tablemate.net/sites/default/files"
  )
  var anArticle =content_data[0]
  setArticleTitle(anArticle.title)
  console.log("Created" + anArticle.created)
  const posterUrl = anArticle.poster_image || anArticle.posterImage
  const videoUrl = anArticle.video_url || anArticle.videoUrl
  const listArticleItems = 
      <div className="doc-article" >
        {posterUrl && (
          <div className="doc-article-poster">
            <img src={posterUrl} alt="" />
          </div>
        )}
        {videoUrl && (
          <div className="doc-article-video">
            {(() => {
              const yt = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
              const vimeo = videoUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
              if (yt) return <iframe src={`https://www.youtube.com/embed/${yt[1]}`} title="Video" allowFullScreen frameBorder="0" />;
              if (vimeo) return <iframe src={`https://player.vimeo.com/video/${vimeo[1]}`} title="Video" allowFullScreen frameBorder="0" />;
              return <video src={videoUrl} controls poster={posterUrl || undefined} />;
            })()}
          </div>
        )}
        <div className="doc-article-body" dangerouslySetInnerHTML={{ __html: page }} />

        <hr></hr>
        <div className="doc-article-application">
          <strong>Application: </strong>{anArticle.application  != null ?  <Link className='details-link' to={`/search?q=${encodeURIComponent(anArticle.application.trim())}`}>{anArticle.application}</Link> : "Sorry, No Content"}
        </div>
        <div className="doc-article-tags">
        <hr></hr>
        <strong>Tags: </strong>
        {anArticle.tags != null &&
        (anArticle.tags.split(',').map((tag, index) => (
            <React.Fragment key={index}>
              {index > 0 && ', '} {/* Add a comma before tags except the first one */}
              <Link className='details-link' to={`/search?q=${encodeURIComponent(tag.trim())}`}>{tag.trim()}</Link>
            </React.Fragment>
          ))
        )
      }
        </div>
        <br></br>
        <div className='doc-article-date'>
          <div><strong>Created: </strong>{TimestampToDateComponent(anArticle.created)}</div>
          <div><strong>Last Updated:</strong> {TimestampToDateComponent(anArticle.changed)}</div>
        </div>
      </div>
    setProjectCategories(listArticleItems)
  return (
    
    listArticleItems
  );
return null;
};

function TimestampToDateComponent(timestamp ) {
  // Convert the Unix timestamp to milliseconds (Unix timestamp is in seconds)
  const date = new Date(timestamp * 1000);

  // Format the date into a readable string
  // You can adjust the options to suit your formatting preferences
  const formattedDate = date.toLocaleDateString("en-US", {
    weekday: 'long', // "Monday"
    year: 'numeric', // "2023"
    month: 'long', // "July"
    day: 'numeric', // "20"
  });

  return (
    formattedDate
  );
}
function capitalizeFirstLetterOfEveryWord(str) {
  return str.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
}

  return(
    <div className="RetaurantCheckin" ref={articleContainerRef}>
      <div className="details-container-page">
      <div className='details-container-page-title'>
        <button className="back-button" onClick={nav_back}>
          <img src={backIcon} alt="Back buutton" />
        </button>
          <h3 className='detailTitle'>{articleTitle}</h3>
        </div>
       
        {docArticle}

        <p className="doc-article-support">
          For any questions/concerns please feel free to contact Table Mate Support - <Link to="/contact">Contact Us</Link>
        </p>
       
      </div>
      {lightboxSrc && (
        <div
          ref={lightboxOverlayRef}
          className={`doc-article-lightbox${lightboxZoom.scale > 1 ? ' is-zoomed' : ''}`}
          role="dialog"
          aria-modal="true"
          aria-label="Expanded image"
          onClick={closeLightbox}
          onTouchStart={(e) => {
            if (e.touches.length === 2) {
              const [a, b] = e.touches;
              lightboxPinchRef.current = {
                distance: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY),
                scale: lightboxZoomRef.current.scale,
              };
              lightboxDragRef.current = null;
            } else if (e.touches.length === 1 && lightboxZoomRef.current.scale > 1) {
              lightboxDragRef.current = {
                startX: e.touches[0].clientX,
                startY: e.touches[0].clientY,
                originX: lightboxZoomRef.current.x,
                originY: lightboxZoomRef.current.y,
              };
            }
          }}
          onTouchMove={(e) => {
            if (e.touches.length === 2 && lightboxPinchRef.current) {
              e.preventDefault();
              const [a, b] = e.touches;
              const distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
              const nextScale = clampZoom(
                lightboxPinchRef.current.scale * (distance / lightboxPinchRef.current.distance)
              );
              setLightboxZoom((prev) =>
                nextScale === 1
                  ? { scale: 1, x: 0, y: 0 }
                  : { ...prev, scale: nextScale }
              );
            } else if (e.touches.length === 1 && lightboxDragRef.current) {
              e.preventDefault();
              const dx = e.touches[0].clientX - lightboxDragRef.current.startX;
              const dy = e.touches[0].clientY - lightboxDragRef.current.startY;
              setLightboxZoom((prev) => ({
                ...prev,
                x: lightboxDragRef.current.originX + dx,
                y: lightboxDragRef.current.originY + dy,
              }));
            }
          }}
          onTouchEnd={() => {
            lightboxPinchRef.current = null;
            lightboxDragRef.current = null;
          }}
        >
          <div className="doc-article-lightbox-toolbar" onClick={(e) => e.stopPropagation()}>
            <button type="button" onClick={() => zoomBy(1 / 1.25)} aria-label="Zoom out" title="Zoom out">−</button>
            <button type="button" onClick={resetZoom} aria-label="Reset zoom" title="Reset zoom">
              {Math.round(lightboxZoom.scale * 100)}%
            </button>
            <button type="button" onClick={() => zoomBy(1.25)} aria-label="Zoom in" title="Zoom in">+</button>
            <button type="button" onClick={downloadLightboxImage} aria-label="Download image" title="Download">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M5 20h14v-2H5v2zm7-18L5.33 9h3.84v6h5.66V9h3.84L12 2z"/></svg>
            </button>
            <button type="button" onClick={printLightboxImage} aria-label="Print image" title="Print">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/></svg>
            </button>
            <button type="button" className="doc-article-lightbox-close" aria-label="Close expanded image" onClick={closeLightbox}>×</button>
          </div>
          <img
            src={lightboxSrc}
            alt=""
            className="doc-article-lightbox-img"
            draggable={false}
            style={{
              transform: `translate(${lightboxZoom.x}px, ${lightboxZoom.y}px) scale(${lightboxZoom.scale})`,
              cursor: lightboxZoom.scale > 1 ? (lightboxDragRef.current ? 'grabbing' : 'grab') : 'zoom-in',
            }}
            onClick={(e) => e.stopPropagation()}
            onDoubleClick={(e) => {
              e.stopPropagation();
              if (lightboxZoom.scale > 1) {
                resetZoom();
              } else {
                const rect = e.currentTarget.parentElement.getBoundingClientRect();
                const originX = e.clientX - rect.left - rect.width / 2;
                const originY = e.clientY - rect.top - rect.height / 2;
                setLightboxZoom({ scale: 2.5, x: -originX * 1.5, y: -originY * 1.5 });
              }
            }}
            onMouseDown={(e) => {
              if (lightboxZoom.scale <= 1 || e.button !== 0) return;
              e.preventDefault();
              e.stopPropagation();
              lightboxDragRef.current = {
                startX: e.clientX,
                startY: e.clientY,
                originX: lightboxZoom.x,
                originY: lightboxZoom.y,
              };
              const onMove = (moveEvent) => {
                if (!lightboxDragRef.current) return;
                const dx = moveEvent.clientX - lightboxDragRef.current.startX;
                const dy = moveEvent.clientY - lightboxDragRef.current.startY;
                setLightboxZoom((prev) => ({
                  ...prev,
                  x: lightboxDragRef.current.originX + dx,
                  y: lightboxDragRef.current.originY + dy,
                }));
              };
              const onUp = () => {
                lightboxDragRef.current = null;
                window.removeEventListener('mousemove', onMove);
                window.removeEventListener('mouseup', onUp);
              };
              window.addEventListener('mousemove', onMove);
              window.addEventListener('mouseup', onUp);
            }}
          />
        </div>
      )}
    </div>
  );
}

export default DocArticle